<template>
  <megabit-base-dialog :show-dialog="true" :width="1024">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.92)" dark dense>
        <v-card-title class="align-self-center">
          <span class="text-h6 white--text">{{
            $t('titulos.cadastroVeiculos')
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.placa')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.placa') })
                  "
                  :maxLength="10"
                  :isRequired="true"
                  v-model="form.PLACA"
                />
              </v-col>
              <v-col md="3" xs="3" sm="2" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.uf')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.uf') })
                  "
                  :maxLength="2"
                  v-model="form.UF"
                />
              </v-col>
              <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.marca')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.marca') })
                  "
                  :maxLength="20"
                  v-model="form.MARCA"
                />
              </v-col>
              <v-col md="3" xs="3" sm="10" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="filiais"
                  :item.sync="form.filial"
                  :rotulo="$t('labels.filial')"
                  v-model="form.FILIAL"
                >
                </c-select>
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="5" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.modelo')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.modelo') })
                  "
                  :maxLength="20"
                  v-model="form.MODELO"
                />
              </v-col>
              <v-col md="3" xs="3" sm="7" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="departamentos"
                  :item.sync="form.departamento"
                  :rotulo="$t('labels.departamento')"
                  v-model="form.DEPARTAMENTO"
                  :loading="loadings.departamento"
                  @searchinput="updateDepartaments($event)"
                >
                </c-select>
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  id="ANO"
                  :label="$t('labels.ano')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.ano') })
                  "
                  :type="'number'"
                  min="1"
                  step="1"
                  :maxLength="4"
                  v-model="form.ANO"
                  @input="validaAno($event)"
                />
              </v-col>
              <v-col md="3" xs="3" sm="5" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.cor')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.cor') })
                  "
                  :maxLength="20"
                  v-model="form.COR"
                />
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.motor')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.motor') })
                  "
                  :maxLength="20"
                  v-model="form.MOTOR"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.combustivel')"
                  :placeholder="
                    $t('placeholders.digite', {
                      campo: $t('labels.combustivel'),
                    })
                  "
                  :maxLength="20"
                  v-model="form.COMBUSTIVEL"
                />
              </v-col>
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.kilometragem')"
                  :placeholder="
                    $t('placeholders.digite', {
                      campo: $t('labels.kilometragem'),
                    })
                  "
                  :type="'number'"
                  v-model="form.KILOMETRAGEM"
                />
              </v-col>
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.numChassi')"
                  :placeholder="
                    $t('placeholders.digite', { campo: $t('labels.numChassi') })
                  "
                  :maxLength="30"
                  v-model="form.CHASSI"
                />
              </v-col>
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="$t('labels.capacidadeKG')"
                  :placeholder="
                    $t('placeholders.digite', {
                      campo: $t('labels.capacidadeKG'),
                    })
                  "
                  type="number"
                  v-model="form.CAPACIDADEKILOS"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="empresas"
                  :item.sync="form.empresa"
                  :isRequired="true"
                  :rotulo="$t('labels.proprietario')"
                  v-model="form.EMPRESA"
                  :loading="loadings.proprietario"
                  @searchinput="updateCompanies($event, 'empresas')"
                />
              </v-col>
              <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="motoristas"
                  :item.sync="form.motorista"
                  :rotulo="$t('labels.motorista')"
                  v-model="form.MOTORISTA"
                  :loading="loadings.motorista"
                  @searchinput="updateCompanies($event, 'motoristas')"
                >
                </c-select>
              </v-col>
              <v-col md="3" xs="3" sm="4" class="d-sm-inline-block">
                <c-input-date
                  :disabled="true"
                  :label="$t('labels.dataUltMov')"
                  v-model.trim="form.DATAULTIMOMOVIMENTO"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="validateForm()" @goBack="goBack()" />
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cInputDate from '@/components/shared/base-input/BaseInputDate'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { vehicleMixin } from '@/mixins/object/vehicle/VehicleMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [vehicleMixin],
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cSelect,
    cInputDate,
    FormButtons,
  },
  data: () => ({
    isUpdate: false,
    registerDialog: true,
    formValid: false,
    search: '',
    id: '',
    empresas: [],
    motoristas: [],
    departamentos: [],
    filiais: [],
    timer: null,
    loadings: {
      departamento: false,
      proprietario: false,
      motorista: false,
    },
    form: {
      PLACA: '',
      UF: '',
      MARCA: '',
      FILIAL: '',
      MODELO: '',
      DEPARTAMENTO: '',
      ANO: '',
      COR: '',
      MOTOR: '',
      COMBUSTIVEL: '',
      KILOMETRAGEM: '',
      CHASSI: '',
      CAPACIDADEKILOS: '',
      EMPRESA: '',
      MOTORISTA: '',
      DATAULTIMOMOVIMENTO: '',
      motorista: '',
      empresa: '',
      departamento: '',
      filial: '',
    },
  }),
  computed: {
    ...mapGetters({ companyList: 'companyModule/getComboBoxList' }),
    ...mapGetters({ departamentList: 'departamentModule/getComboBoxListDeps' }),
    ...mapGetters({ systemList: 'systemModule/getComboBoxListSystems' }),
    // Ver o breakpoint da página
    // breakpoint() {
    //   return this.$vuetify.breakpoint.name;
    // },
  },
  methods: {
    ...mapActions('vehicleModule', [
      'getVehicle',
      'updateVehicle',
      'insertVehicle',
    ]),
    ...mapActions('companyModule', ['getCompanies']),
    ...mapActions('departamentModule', ['getDepartaments']),
    ...mapActions('systemModule', ['getSystems']),
    ...mapActions('dialogModule', [
      'setShowLoadingDialog',
      'setLoadingDialogMessage',
    ]),
    async validateForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error(this.$t('validation-messages.corrigir'))
        return
      }

      try {
        this.setShowLoadingDialog(true)
        this.setLoadingDialogMessage(this.$t('messages.enviarRegistro'))
        let response
        if (!this.isUpdate) {
          response = await this.insertVehicle(this.form)
        } else {
          response = await this.updateVehicle({ form: this.form, id: this.id })
        }
        this.$toasted.success(response)
        this.goBack()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        this.setShowLoadingDialog(false)
      }
    },
    async setData(id = null) {
      try {
        let emp, mot, fil, dep
        if (id) {
          this.title = `${this.$t('titulo.alteracaoVeiculo')}`
          let vehicle = await this.getVehicle(id)
          this.form = {
            ...vehicle,
          }
          emp = this.form.empresa
            ? [
                {
                  CODIGO: this.form.empresa.CODIGO,
                  DESCRICAO:
                    this.form.empresa.CODIGO + ' - ' + this.form.empresa.NOME,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: this.$t('labels.semDados') }]
          this.empresas = emp
          mot = this.form.motorista
            ? [
                {
                  CODIGO: this.form.motorista.CODIGO,
                  DESCRICAO:
                    this.form.motorista.CODIGO +
                    ' - ' +
                    this.form.motorista.NOME,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: this.$t('labels.semDados') }]
          this.motoristas = mot
          dep =
            this.form.departamento != undefined
              ? [
                  {
                    CODIGO: this.form.departamento.CODIGO,
                    DESCRICAO:
                      this.form.departamento.CODIGO +
                      ' - ' +
                      this.form.departamento.DESCRICAO,
                  },
                ]
              : [{ CODIGO: '', DESCRICAO: this.$t('labels.semDados') }]
          this.departamentos = dep
          fil = this.form.filial
            ? {
                CODIGO: this.form.filial.CODIGO,
                DESCRICAO:
                  this.form.filial.CODIGO + ' - ' + this.form.filial.NOME,
              }
            : ''
          this.form.filial = fil
          await this.getFiliais()
          this.isUpdate = !this.isUpdate
        } else {
          // Inclusão de Veículos
          await this.getFiliais()
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })

        try {
          this.setShowLoadingDialog(true)
          this.setLoadingDialogMessage(this.$t('messages.enviarRegistro'))
          let response
          if (!this.isUpdate) {
            response = await this.insertVehicle(this.form)
          } else {
            response = await this.updateVehicle({
              form: this.form,
              id: this.id,
            })
          }
          this.$toasted.success(response)
          this.goBack()
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        } finally {
          this.setShowLoadingDialog(false)
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'Veiculo' })
    },
    validaAno() {
      document.getElementById('ANO').value = this.form.ANO.replace(/\D+/g, '')
    },
    /*  Atualiza ComboBox do Proprietário
        por código ou nome da Empresa
     */
    async updateCompanies($event, tipo) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let obj = parseInt(param)
            ? { page: 1, codigo: param }
            : { page: 1, nome: param }
          this.getDados(obj, tipo)
        }, 600)
      } catch (error) {
        this.$toasted.error(`Erro na função updateCompanies ${error}`)
      }
    },
    async getDados(payload, tipo) {
      try {
        tipo == 'empresas'
          ? (this.loadings.proprietario = true)
          : (this.loadings.motorista = true)
        await this.getCompanies(payload)
        if (tipo == 'empresas') {
          this.empresas = this.companyList
        } else {
          this.motoristas = this.companyList
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      } finally {
        tipo == 'empresas'
          ? (this.loadings.proprietario = false)
          : (this.loadings.motorista = false)
      }
    },
    /*  Atualiza o ComboBox do Departamento
        por código ou nome do Departamento
    */
    async updateDepartaments($event) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          this.loadings.departamento = true
          let params =
            $event && $event.target.value ? $event.target.value : null
          let obj = parseInt(params, 10)
            ? { page: 1, codigo: params }
            : { page: 1, descricao: params }
          await this.getDeps(obj)
          this.loadings.departamento = false
        }, 600)
      } catch (error) {
        this.$toasted.error(`Erro na função updateDepartaments() ${error}`)
      }
    },
    async getDeps(obj) {
      try {
        await this.getDepartaments(obj)
        this.departamentos = this.departamentList
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    /*
      Obtém lista de filiais
    */
    async getFiliais(payload) {
      try {
        await this.getSystems(payload)
        this.filiais = this.systemList
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
  mounted: function() {
    this.id = this.$route.params.id
    this.setData(this.id)
  },
  created: function() {},
}
</script>
